module.exports = __webpack_public_path__ + "static/img/product02_03.5be06b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product02/product02_03.jpg
// module id = N99F
// module chunks = 1